// Path: ./src/hooks/useMenuTagOptions.ts
import { useState, useEffect, useCallback } from "react";
import { adminApiService } from "../utils/api";
import { GfMenuTag } from "@swagger/typescript-fetch-goflyer";

export const useMenuTagOptions = () => {
  const [menuTagOptionList, setMenuTagOptionList] = useState<GfMenuTag[]>();

  const fetchMenuTags = useCallback(async () => {
    try {
      const menuTagData =
        await adminApiService.getManyBaseGfMenuTagAdminControllerGfMenuTag();

      setMenuTagOptionList(menuTagData.data);
    } catch (error) {
      console.error("Error fetching menu tags:", error);
    }
  }, []);

  useEffect(() => {
    fetchMenuTags();
  }, []);

  return { menuTagOptionList, fetchMenuTags };
};
